export default "__VITE_ASSET__J0ZN5TV$__"